var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.015625,
    width: 39.9698,
    height: 40,
    rx: 19.9849,
    fill: "#9983FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9717 22.3513C23.1831 22.3513 25.8936 22.8736 25.8936 24.8884C25.8933 26.9038 23.1651 27.407 19.9717 27.407C16.7611 27.407 14.0508 26.8847 14.0508 24.8699C14.0512 22.8547 16.7784 22.3513 19.9717 22.3513ZM19.9717 12.5925C22.147 12.5926 23.8895 14.3361 23.8896 16.5115C23.8896 18.687 22.1471 20.4313 19.9717 20.4314C17.797 20.4314 16.0527 18.6871 16.0527 16.5115C16.0529 14.3361 17.7971 12.5925 19.9717 12.5925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccount);
export default __webpack_public_path__ + "static/media/user-account.b2e495db5ade290a033cef64f6503047.svg";
export { ForwardRef as ReactComponent };